import positionMaintenance from "../positionMaintenance/PositionMaintenance";
import positionAuditRemark from "../positionAuditRemark/PositionAuditRemark";
import MaintenanceField from "../positionMaintenance/MaintenanceField";
import SystemSetting from '../systemSetting/SystemSetting';
import ZombieAccountSetting from "../zombieAccountSetting/ZombieAccountSetting";

export  const  positionSystemSettingRoute =[
    {
        path: "/newMedia/positionMaintenance",
        component: positionMaintenance
    },
    {
        path: "/newMedia/maintenanceField/:id",
        component: MaintenanceField
    },
    {
        path: "/newMedia/positionAuditRemark",
        component: positionAuditRemark
    },
    {
        path: "/newMedia/systemSetting",
        component: SystemSetting,
    },
    {
        path: "/newMedia/zombieAccount",
        component: ZombieAccountSetting,
    },
];